module.exports = __webpack_public_path__ + "fonts/shipnity.68ceb0ff.woff";